import { StyleFilter, ComponentFilter } from "@globalTypes"

export const uidToComponents = {
  gemstones: ComponentFilter.stone,
  frames: ComponentFilter.frame,
  bases: ComponentFilter.base,
}

export const articleFilters = {
  gemstones: [StyleFilter.classic, StyleFilter.oval, StyleFilter.hippiechic],
  bases: [StyleFilter.classic, StyleFilter.oval, StyleFilter.hippiechic],
  frames: [StyleFilter.classic, StyleFilter.oval],
}
